module.exports = __webpack_public_path__ + "static/media/background_3.492e28ce.jpg";